import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Typography } from '@mui/material';
import { ElementType } from 'react';
import useWidth from '../../../../../components/Hooks/useWidth';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';

const LABEL_MAX_WIDTH = '30ch';

interface PublicNavigationTabProps {
  icon: ElementType;
  label: LangEnum;
  labelParams?: Record<string, string>;
  isActive: boolean;
  testId: string;
  onClick: () => void;
}

const PublicNavigationTab = ({
  icon,
  label,
  labelParams,
  isActive,
  testId,
  onClick,
}: PublicNavigationTabProps) => {
  const { smallWidth } = useWidth();
  const { translate } = useTranslation();

  const translatedLabel = translate(label, labelParams);

  if (smallWidth) {
    return (
      <IconButton
        icon={icon}
        color="secondary"
        isActive={isActive}
        testId={testId}
        ariaLabel={translatedLabel}
        onClick={onClick}
      />
    );
  }

  return (
    <Button
      testId={testId}
      color="secondary"
      variant="contained"
      size="medium"
      shape="square"
      startIcon={<Icon icon={icon} size="md" />}
      isActive={isActive}
      onClick={onClick}
    >
      <Typography noWrap component="span" variant="inherit" sx={{ maxWidth: LABEL_MAX_WIDTH }}>
        {translatedLabel}
      </Typography>
    </Button>
  );
};

export default PublicNavigationTab;
